const MODULE_NAME = 'PATIENT_NOTICES';
const PATIENT_NOTICES_FETCH_STARTED = MODULE_NAME + 'FETCH_STARTED';
const PATIENT_NOTICES_FETCH_ERROR = MODULE_NAME + 'FETCH_ERROR';
const PATIENT_NOTICES_FETCH_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';
const PATIENT_NOTICES_CLEAR = MODULE_NAME + 'CLEAR';

export {
  PATIENT_NOTICES_FETCH_STARTED,
  PATIENT_NOTICES_FETCH_ERROR,
  PATIENT_NOTICES_FETCH_COMPLETED,
  PATIENT_NOTICES_CLEAR
};
